// extracted by mini-css-extract-plugin
export default {"searchIconStyle":"searchIconStyles_searchIconStyle__7v6hB"};